export default __webpack_public_path__ + "static/skills-tag-parts-light-a94e78880f42d5c594f5a12ffcc1410c6ec9cf8415d9893aeb8c2aa4be54a898.png";